<mat-card class="mat-elevation-z8" style="padding: 1rem 1.5rem !important;">

  <!-- Header -->
  <div class="section-header">
    <div class="section-title">
      <mat-icon>history</mat-icon>
      Histórico de Comunicações
      <span class="total-badge" *ngIf="!loading && !error && totalItems > 0">{{ totalItems }} registros</span>
    </div>
    <button mat-icon-button color="primary" (click)="carregarHistorico()" matTooltip="Atualizar" [disabled]="loading">
      <mat-icon>autorenew</mat-icon>
    </button>
  </div>

  <!-- Filter bar: chips de canal -->
  <div class="filter-bar">
    <span
      *ngFor="let c of canais"
      class="chip-filter"
      [ngClass]="[c.css, canalAtivo !== null && canalAtivo !== c.valor ? 'inactive' : '']"
      (click)="toggleCanal(c.valor)">
      <mat-icon style="font-size:14px;width:14px;height:14px;line-height:14px">{{ c.icon }}</mat-icon>
      {{ c.label }}
    </span>
  </div>

  <mat-card-content>

    <!-- Loading -->
    <div class="loading-shade" *ngIf="loading">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Erro -->
    <ng-container *ngIf="!loading && error">
      <div class="state-panel state-error">
        <mat-icon>error_outline</mat-icon>
        <p>Erro ao carregar histórico. Tente novamente.</p>
        <button mat-stroked-button color="warn" (click)="carregarHistorico()">
          <mat-icon>refresh</mat-icon> Tentar novamente
        </button>
      </div>
    </ng-container>

    <!-- Empty state -->
    <ng-container *ngIf="!loading && !error && mensagens.length === 0">
      <div class="state-panel state-empty">
        <mat-icon>mail_outline</mat-icon>
        <p>Nenhuma mensagem enviada para este aluno.</p>
      </div>
    </ng-container>

    <!-- Tabela -->
    <ng-container *ngIf="!loading && !error && mensagens.length > 0">
      <div style="overflow-x:auto">
        <table mat-table [dataSource]="mensagens" class="com-table">

          <!-- Data Envio -->
          <ng-container matColumnDef="dataEnvio">
            <th mat-header-cell *matHeaderCellDef>Data de Envio</th>
            <td mat-cell *matCellDef="let row">{{ row.dataEnvio | date:'dd/MM/yyyy HH:mm' }}</td>
          </ng-container>

          <!-- Canal -->
          <ng-container matColumnDef="canal">
            <th mat-header-cell *matHeaderCellDef>Canal</th>
            <td mat-cell *matCellDef="let row">
              <span class="chip-canal" [ngClass]="getCanalCss(row.canal)">
                <mat-icon style="font-size:13px;width:13px;height:13px;line-height:13px">{{ getCanalIcon(row.canal) }}</mat-icon>
                {{ getCanalLabel(row.canal) }}
              </span>
            </td>
          </ng-container>

          <!-- Título -->
          <ng-container matColumnDef="titulo">
            <th mat-header-cell *matHeaderCellDef>
              Título
              <input class="col-filter" type="text" placeholder="Filtrar..." [formControl]="filtroTituloControl" (click)="$event.stopPropagation()">
            </th>
            <td mat-cell *matCellDef="let row">{{ row.titulo }}</td>
          </ng-container>

          <!-- Regra -->
          <ng-container matColumnDef="regraNome">
            <th mat-header-cell *matHeaderCellDef>
              Regra
              <input class="col-filter" type="text" placeholder="Filtrar..." [formControl]="filtroRegraControl" (click)="$event.stopPropagation()">
            </th>
            <td mat-cell *matCellDef="let row">{{ row.regraNome || '—' }}</td>
          </ng-container>

          <!-- Tentativa -->
          <ng-container matColumnDef="tentativa">
            <th mat-header-cell *matHeaderCellDef>Tentativa</th>
            <td mat-cell *matCellDef="let row">{{ row.tentativa }}</td>
          </ng-container>

          <!-- Status -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row">
              <span class="chip-status"
                [ngClass]="row.envioComSucesso === true ? 'chip-ok' : row.envioComSucesso === false ? 'chip-err' : 'chip-pend'">
                <mat-icon style="font-size:13px;width:13px;height:13px;line-height:13px">
                  {{ row.envioComSucesso === true ? 'check' : row.envioComSucesso === false ? 'close' : 'schedule' }}
                </mat-icon>
                {{ row.envioComSucesso === true ? 'Enviado' : row.envioComSucesso === false ? 'Falhou' : 'Pendente' }}
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

      <mat-paginator
        [length]="totalItems"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPageChange($event)"
        showFirstLastButtons>
      </mat-paginator>
    </ng-container>

  </mat-card-content>
</mat-card>
